import React from "react";

export default function ScreenCapturePanelRefurbishment(
{
    recommendations,
    hoveredId,
    setHoveredId,
    hasCoordinates
})
{
    function getPriorityColour(priority)
    {
        if (!priority)
        {
            return "#888";
        }

        switch (priority.toLowerCase())
        {
            case "low":
                return "#4CAF50";

            case "medium":
                return "#FFC107";

            case "high":
                return "#F44336";

            default:
                return "#888";
        }
    }

    function getCostColour(cost)
    {
        if (!cost)
        {
            return "#888";
        }

        switch (cost.toLowerCase())
        {
            case "low":
                return "#4CAF50";

            case "medium":
                return "#FFC107";

            case "high":
                return "#F44336";

            default:
                return "#888";
        }
    }

    return (

        <div
            style={{
                width: "360px",
                background: "#111",
                color: "#fff",
                padding: "20px",
                overflowY: "auto"
            }}
        >

            <div
                style={{
                    fontSize: "20px",
                    marginBottom: "4px"
                }}
            >
                Refurbishment Planner
            </div>

            <div
                style={{
                    fontSize: "12px",
                    color: "#888",
                    marginBottom: "20px"
                }}
            >
                AI generated refurbishment opportunities
            </div>

            {recommendations.map(function(item)
            {
                const priorityColour =
                    getPriorityColour(item.priority);

                const costColour =
                    getCostColour(item.estimatedCost);

                return (

                    <div
                        key={item.id}
                        onMouseEnter={function()
                        {
                            setHoveredId(item.id);
                        }}
                        onMouseLeave={function()
                        {
                            setHoveredId(null);
                        }}
                        style={{
                            padding: "14px 0",
                            borderBottom: "1px solid #333",
                            cursor: "pointer",
                            background:
                                hoveredId === item.id
                                    ? "#1a1a1a"
                                    : "transparent"
                        }}
                    >

                        <div
                            style={{
                                fontWeight: "bold",
                                fontSize: "15px",
                                color:
                                    hoveredId === item.id
                                        ? "#5a9bd6"
                                        : "#fff"
                            }}
                        >
                            {item.title}
                        </div>

                        <div
                            style={{
                                display: "flex",
                                gap: "8px",
                                marginTop: "8px"
                            }}
                        >

                            <div
                                style={{
                                    background: priorityColour + "22",
                                    color: priorityColour,
                                    padding: "3px 8px",
                                    borderRadius: "999px",
                                    fontSize: "11px"
                                }}
                            >
                                {item.priority}
                            </div>

                            <div
                                style={{
                                    background: costColour + "22",
                                    color: costColour,
                                    padding: "3px 8px",
                                    borderRadius: "999px",
                                    fontSize: "11px"
                                }}
                            >
                                Cost: {item.estimatedCost}
                            </div>

                        </div>

                        {item.recommendation &&

                            <div
                                style={{
                                    marginTop: "10px",
                                    fontSize: "12px",
                                    color: "#ddd",
                                    lineHeight: "1.5"
                                }}
                            >
                                {item.recommendation}
                            </div>

                        }

                        {item.expectedBenefit &&

                            <div
                                style={{
                                    marginTop: "10px",
                                    color: "#8FD694",
                                    fontSize: "12px"
                                }}
                            >
                                Expected Benefit:
                                <br/>
                                {item.expectedBenefit}
                            </div>

                        }

                        <div
                            style={{
                                display: "flex",
                                gap: "10px",
                                marginTop: "15px"
                            }}
                        >

                            <button
                                style={{
                                    flex: 1,
                                    background: "#5a9bd6",
                                    border: "none",
                                    color: "#fff",
                                    borderRadius: "6px",
                                    padding: "8px",
                                    cursor: "pointer"
                                }}
                            >
                                Create Project
                            </button>

                            <button
                                style={{
                                    background: "#222",
                                    border: "1px solid #444",
                                    color: "#ddd",
                                    borderRadius: "6px",
                                    padding: "8px 12px",
                                    cursor: "pointer"
                                }}
                            >
                                Ignore
                            </button>

                        </div>

                    </div>

                );

            })}

        </div>

    );
}